<template>
  <div class="p-4">
    <h2 class="text-lg font-semibold mb-4">Технологии</h2>
    <table class="w-full border-collapse bg-white shadow-md">
      <thead class="bg-gray-100">
      <tr>
        <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">#</th>
        <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Название</th>
        <th class="px-4 py-2 text-left text-sm font-medium text-gray-700"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(technology, index) in technologies" :key="technology.id" class="border-b hover:bg-gray-50">
        <td class="px-4 py-2 text-sm text-gray-700">{{ index + 1 }}</td>
        <td class="px-4 py-2 text-sm text-gray-700">
          <button
            @click="viewDetail(technology.technology.name)"
            class="text-sm font-medium text-blue-600 text-left"
          >
            {{ technology.technology.name }}
          </button>
        </td>
        <td class="px-4 py-2 w-[250px]">
          <div class="flex justify-end space-x-2">
            <DeleteButton :title="'технологию'" @click="removeTechnology(technology.technology.name)" />
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DeleteButton from "@/components/DeleteButton.vue";

export default {
  components: { DeleteButton },
  props: {
    data:
      {
        type: Array,
        required: true,
      },
  },
  computed: {
    technologies() {
      return this.data;
    },
  },
  methods: {
    removeTechnology(technologyName) {
      this.$emit('removeTechnology', technologyName);
    },
    viewDetail(name) {
      this.$emit("viewDetail", name);
    },
  },
};
</script>
